module.exports = __webpack_public_path__ + "img/webstreamsite_1200.977604f1.png";